import { useTranslation } from 'react-i18next';

type Section = { heading: string; body: string };
type LangContent = {
  title: string;
  intro: string;
  sections: Section[];
  contactHeading: string;
  contactValue: string;
};

const CONTACT = 'Email: mezes3758@gmail.com · Telegram: @tez_japan_support_bot';

const CONTENT: Record<'uz' | 'ru' | 'en', LangContent> = {
  uz: {
    title: 'Maxfiylik siyosati',
    intro:
      '"Tez Cargo Japan" — bu ushbu ilovani taqdim etuvchi Yaponiyadan Oʻzbekistonga yuk tashish xizmati. Ushbu siyosat qanday maʼlumotlar toʻplanishi va ulardan qanday foydalanilishini tushuntiradi.',
    sections: [
      {
        heading: 'Toʻplaydigan maʼlumotlar',
        body: 'Google orqali kirishda ism va elektron pochta; profilingizdan telefon raqami va manzil; posilka/yuk haqidagi maʼlumotlar; hamda ilova ishlashi uchun qurilma identifikatori.',
      },
      {
        heading: 'Maʼlumotlardan qanday foydalanamiz',
        body: 'Yuk tashish va yetkazib berish xizmatini koʻrsatish, buyurtmalaringizni boshqarish va siz bilan bogʻlanish uchun foydalanamiz.',
      },
      {
        heading: 'Maʼlumotlarni ulashish',
        body: 'Biz maʼlumotlaringizni sotmaymiz va reklama maqsadida uchinchi tomonlarga bermaymiz. Ular faqat yuklaringizni yetkazish uchun zarur boʻlgan tegishli yetkazib berish hamkorlari bilan ulashiladi.',
      },
      {
        heading: 'Xavfsizlik',
        body: 'Maʼlumotlar shifrlangan HTTPS orqali uzatiladi.',
      },
      {
        heading: 'Maʼlumotlarni saqlash',
        body: 'Maʼlumotlar hisobingiz faol boʻlgan davrda saqlanadi. Hisob oʻchirilgandan soʻng shaxsiy maʼlumotlaringiz oʻchiriladi, ammo posilka/toʻlov yozuvlari qonun va buxgalteriya talab qilgan muddat davomida anonim tarzda saqlanishi mumkin.',
      },
      {
        heading: 'Sizning huquqlaringiz',
        body: 'Maʼlumotlaringizga kirishingiz va hisobni oʻchirishni soʻrashingiz mumkin — ilova ichida (Profil → Hisobni oʻchirish) yoki Hisobni oʻchirish sahifasi orqali.',
      },
    ],
    contactHeading: 'Aloqa',
    contactValue: CONTACT,
  },
  ru: {
    title: 'Политика конфиденциальности',
    intro:
      '"Tez Cargo Japan" — это служба доставки грузов из Японии в Узбекистан, предоставляющая данное приложение. Настоящая политика объясняет, какие данные собираются и как они используются.',
    sections: [
      {
        heading: 'Какие данные мы собираем',
        body: 'Имя и электронная почта при входе через Google; телефон и адрес из вашего профиля; информация о посылке/грузе; а также идентификатор устройства для работы приложения.',
      },
      {
        heading: 'Как мы используем данные',
        body: 'Для предоставления услуги доставки грузов, управления вашими заказами и связи с вами.',
      },
      {
        heading: 'Передача данных',
        body: 'Мы не продаём ваши данные и не передаём их третьим лицам для рекламы. Они передаются только соответствующим партнёрам по доставке в объёме, необходимом для выполнения ваших отправлений.',
      },
      {
        heading: 'Безопасность',
        body: 'Данные передаются по зашифрованному протоколу HTTPS.',
      },
      {
        heading: 'Хранение данных',
        body: 'Данные хранятся, пока ваша учётная запись активна. После удаления учётной записи ваши персональные данные удаляются, однако записи о посылках/платежах могут сохраняться анонимно в течение срока, требуемого законом и бухгалтерским учётом.',
      },
      {
        heading: 'Ваши права',
        body: 'Вы можете получить доступ к своим данным и запросить удаление учётной записи — в приложении (Профиль → Удалить аккаунт) или через страницу удаления аккаунта.',
      },
    ],
    contactHeading: 'Контакты',
    contactValue: CONTACT,
  },
  en: {
    title: 'Privacy Policy',
    intro:
      '"Tez Cargo Japan" is a Japan-to-Uzbekistan cargo service that provides this app. This policy explains what data is collected and how it is used.',
    sections: [
      {
        heading: 'Data we collect',
        body: 'Name and email via Google sign-in; phone and address from your profile; parcel/cargo information; and a device identifier for app functionality.',
      },
      {
        heading: 'How we use it',
        body: 'To provide the cargo and delivery service, manage your orders, and contact you.',
      },
      {
        heading: 'Sharing',
        body: 'We do not sell your data and do not share it with third parties for advertising. It is shared only with relevant delivery partners as needed to fulfill your shipments.',
      },
      {
        heading: 'Security',
        body: 'Data is transmitted over encrypted HTTPS.',
      },
      {
        heading: 'Retention',
        body: 'Data is kept while your account is active. After account deletion your personal data is removed, but parcel/payment records may be retained anonymously for the period required by law and accounting.',
      },
      {
        heading: 'Your rights',
        body: 'You can access your data and request account deletion — in-app (Profile → Delete account) or via the Account Deletion page.',
      },
    ],
    contactHeading: 'Contact',
    contactValue: CONTACT,
  },
};

export const PagesPrivacyMain = () => {
  const { i18n } = useTranslation();
  const lang = (['uz', 'ru', 'en'].includes(i18n.language) ? i18n.language : 'uz') as
    | 'uz'
    | 'ru'
    | 'en';
  const c = CONTENT[lang];

  return (
    <div className="mx-auto max-w-2xl px-5 py-8">
      <h1 className="text-2xl font-semibold text-ink mb-2">{c.title}</h1>
      <p className="text-sm leading-relaxed text-ink-muted">{c.intro}</p>

      {c.sections.map((section) => (
        <section key={section.heading}>
          <h2 className="text-lg font-semibold text-ink mt-6 mb-2">{section.heading}</h2>
          <p className="text-sm leading-relaxed text-ink-muted">{section.body}</p>
        </section>
      ))}

      <section>
        <h2 className="text-lg font-semibold text-ink mt-6 mb-2">{c.contactHeading}</h2>
        <p className="text-sm leading-relaxed text-ink-faint">{c.contactValue}</p>
      </section>
    </div>
  );
};
